export default {
  methods: {
    redirectUser (user) {
      switch (user.role) {
        case 'admin':
          this.$router.push({ name: 'admin-dashboard' })
          break

        case 'participant':
          this.$router.push({ name: 'participant-dashboard' })
          break

        case 'judge':
          this.$router.push({ name: 'judge-dashboard' })
          break
      }
    }
  }
}
